import unitHelper from '@client/helper/unit';

// 求和
export function statisticSum(data = [], key) {
  if (!key || !Array.isArray(data) || data.length === 0) {
    return 0;
  }

  if (typeof key === 'string') {
    return data.reduce((total, item, index) => {
      return total + (typeof item[key] !== 'number' ? 0 : item[key]);
    }, 0);
  }

  if (Array.isArray(key)) {
    return data.reduce((total, item, index) => {
      let value = 0;

      for (let n = 0, length = key.length; n < length; n++) {
        if (item[key[n]] === 'number') {
          value = item[key[n]];
          break;
        }
      }

      return total + value;
    }, 0);
  }
  return 0;
}

// 求平均值
export function statisticAvg(data = [], key) {
  if (!key || !Array.isArray(data) || data.length === 0) {
    return 0;
  }

  let count = 0;
  let value = 0;
  data.forEach((item) => {
    if (typeof key === 'string') {
      if (unitHelper.isNoValue(item[key]) || typeof item[key] !== 'number') {
        value += 0;
      } else {
        count++;
        value += item[key];
      }
    }

    if (Array.isArray(key)) {
      for (let n = 0, length = key.length; n < length; n++) {
        if (typeof item[key[n]] === 'number' && item[key[n]]) {
          count++;
          value += item[key[n]];
          break;
        }
      }
    }
  });
  return count === 0 ? count : value / count;
}

// 求最大值
export function statisticMax(data = [], key) {
  if (!key || !Array.isArray(data) || data.length === 0) {
    return 0;
  }
  return data.reduce((total, item, index) => {
    let value = '';
    if (typeof key === 'string') {
      value = typeof item[key] !== 'number' ? 0 : item[key];
    }

    if (Array.isArray(key)) {
      for (let n = 0, length = key.length; n < length; n++) {
        if (typeof item[key[n]] === 'number') {
          value = item[key[n]];
          break;
        }
      }
    }

    if (key === 'totalDescent') {
      console.log(value, total);
    }
    return typeof value === 'number' && value > total ? value : total;
  }, 0);
}

export function distanceStatistic({ dataInFrameSelection, unitType, sportType }) {
  const startIndex = 0;
  const endIndex = dataInFrameSelection.length - 1;
  let distance = dataInFrameSelection[endIndex].distance - dataInFrameSelection[startIndex].distance;

  distance = distance / 100;

  return unitHelper.getDistanceInfo(sportType, distance, unitType);
}

export function timeStatistic({ dataInFrameSelection }) {
  const startIndex = 0;
  const endIndex = dataInFrameSelection.length - 1;
  const millisecond = dataInFrameSelection[endIndex].activityTimestamp - dataInFrameSelection[startIndex].activityTimestamp;

  const value = unitHelper.s2hms(Math.round(millisecond / 100));

  return {
    value,
    unit: ''
  };
}
